import CzechReferenceDataSources from './CzechReferenceDataSources';
import ProductCompliance, { Resolution } from './ProductCompliance';

export interface RawProductCompliance {
	resolution: string;
	ruleDescription: string | null;
	decisionComment: string | null;
	czechReferenceDataSources: {
		version: string;
		effectiveSince: string;
	};
}

export default function mapProductCompliance(compliance: RawProductCompliance): ProductCompliance {
	return new ProductCompliance(
		compliance.resolution as Resolution,
		compliance.ruleDescription,
		compliance.decisionComment,
		new CzechReferenceDataSources(
			compliance.czechReferenceDataSources.version,
			new Date(compliance.czechReferenceDataSources.effectiveSince)
		)
	);
}
